<template>
  <v-layout row justify-center>
    <v-dialog v-model="open" max-width="358px">
      <v-card>
        <v-card-text class="pt-4 pl-4" style="font-weight: 510; padding-bottom: 0px; font-size:20px">{{heading}}</v-card-text>
         <v-card-text class="pl-4" style="font-size:12px; color:black;  font-weight: 500; padding-bottom: 20px;">{{message}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="background-color: white;color: #041e41;" dark depressed @click="open= false">Cancelar</v-btn>
          <v-btn color="#00aeef" dark @click="$emit('onConfirm')">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  props: ["heading", "message", "onConfirm"],
  data() {
    return {
      open: false
    };
  },
  methods: {
      openDialog(){
          this.open=true;
      },
      close(){
          this.open=false;
      }
  }
}
</script>